// source: terrain.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var models_pb = require('./models_pb.js');
goog.object.extend(proto, models_pb);
goog.exportSymbol('proto.proto.terrain.TerrainRequest', null, global);
goog.exportSymbol('proto.proto.terrain.TerrainResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.terrain.TerrainRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.terrain.TerrainRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.terrain.TerrainRequest.displayName = 'proto.proto.terrain.TerrainRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.terrain.TerrainResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.terrain.TerrainResponse.repeatedFields_, null);
};
goog.inherits(proto.proto.terrain.TerrainResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.terrain.TerrainResponse.displayName = 'proto.proto.terrain.TerrainResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.terrain.TerrainRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.terrain.TerrainRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.terrain.TerrainRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.terrain.TerrainRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.terrain.TerrainRequest}
 */
proto.proto.terrain.TerrainRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.terrain.TerrainRequest;
  return proto.proto.terrain.TerrainRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.terrain.TerrainRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.terrain.TerrainRequest}
 */
proto.proto.terrain.TerrainRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.terrain.TerrainRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.terrain.TerrainRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.terrain.TerrainRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.terrain.TerrainRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.proto.terrain.TerrainRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.terrain.TerrainRequest} returns this
 */
proto.proto.terrain.TerrainRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.terrain.TerrainResponse.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.terrain.TerrainResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.terrain.TerrainResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.terrain.TerrainResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.terrain.TerrainResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    hasmetadata: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    cols: jspb.Message.getFieldWithDefault(msg, 2, 0),
    rows: jspb.Message.getFieldWithDefault(msg, 3, 0),
    cellsize: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    lowerleftx: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    lowerlefty: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    cellsList: jspb.Message.toObjectList(msg.getCellsList(),
    models_pb.Cell.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.terrain.TerrainResponse}
 */
proto.proto.terrain.TerrainResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.terrain.TerrainResponse;
  return proto.proto.terrain.TerrainResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.terrain.TerrainResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.terrain.TerrainResponse}
 */
proto.proto.terrain.TerrainResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasmetadata(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCols(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRows(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCellsize(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLowerleftx(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLowerlefty(value);
      break;
    case 7:
      var value = new models_pb.Cell;
      reader.readMessage(value,models_pb.Cell.deserializeBinaryFromReader);
      msg.addCells(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.terrain.TerrainResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.terrain.TerrainResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.terrain.TerrainResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.terrain.TerrainResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHasmetadata();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getCols();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getRows();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCellsize();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getLowerleftx();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getLowerlefty();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getCellsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      models_pb.Cell.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool HasMetadata = 1;
 * @return {boolean}
 */
proto.proto.terrain.TerrainResponse.prototype.getHasmetadata = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.terrain.TerrainResponse} returns this
 */
proto.proto.terrain.TerrainResponse.prototype.setHasmetadata = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional int32 Cols = 2;
 * @return {number}
 */
proto.proto.terrain.TerrainResponse.prototype.getCols = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.terrain.TerrainResponse} returns this
 */
proto.proto.terrain.TerrainResponse.prototype.setCols = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 Rows = 3;
 * @return {number}
 */
proto.proto.terrain.TerrainResponse.prototype.getRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.terrain.TerrainResponse} returns this
 */
proto.proto.terrain.TerrainResponse.prototype.setRows = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double CellSize = 4;
 * @return {number}
 */
proto.proto.terrain.TerrainResponse.prototype.getCellsize = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.terrain.TerrainResponse} returns this
 */
proto.proto.terrain.TerrainResponse.prototype.setCellsize = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double LowerLeftX = 5;
 * @return {number}
 */
proto.proto.terrain.TerrainResponse.prototype.getLowerleftx = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.terrain.TerrainResponse} returns this
 */
proto.proto.terrain.TerrainResponse.prototype.setLowerleftx = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double LowerLeftY = 6;
 * @return {number}
 */
proto.proto.terrain.TerrainResponse.prototype.getLowerlefty = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.terrain.TerrainResponse} returns this
 */
proto.proto.terrain.TerrainResponse.prototype.setLowerlefty = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * repeated proto.models.Cell Cells = 7;
 * @return {!Array<!proto.proto.models.Cell>}
 */
proto.proto.terrain.TerrainResponse.prototype.getCellsList = function() {
  return /** @type{!Array<!proto.proto.models.Cell>} */ (
    jspb.Message.getRepeatedWrapperField(this, models_pb.Cell, 7));
};


/**
 * @param {!Array<!proto.proto.models.Cell>} value
 * @return {!proto.proto.terrain.TerrainResponse} returns this
*/
proto.proto.terrain.TerrainResponse.prototype.setCellsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.proto.models.Cell=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.models.Cell}
 */
proto.proto.terrain.TerrainResponse.prototype.addCells = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.proto.models.Cell, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.terrain.TerrainResponse} returns this
 */
proto.proto.terrain.TerrainResponse.prototype.clearCellsList = function() {
  return this.setCellsList([]);
};


goog.object.extend(exports, proto.proto.terrain);
